export interface TableSortItem {
  key: string; order: 'asc' | 'desc'
}

const SORT_KEY_OVERRIDES: Record<string, string> = {
  name: 'sort_name',
  number: 'sort_number',
  section: 'sections_content',
}

/** Преобразует сортировку колонки таблицы в параметр API ?sort= */
export function mapColumnSortToApi(sort?: TableSortItem): string | undefined {
  if (!sort) {
    return undefined
  }

  const apiKey = SORT_KEY_OVERRIDES[sort.key] ?? sort.key

  return sort.order === 'desc' ? `-${apiKey}` : apiKey
}
